import React, { Dispatch } from 'react'
import { Route, match, RouteComponentProps, Switch } from 'react-router'
import {
  HistoryButtonsAction,
  ShowRoutesParams,
  pushLocation,
  clearHistory,
} from './reducer'

function useSetHistory(
  match: match<ShowRoutesParams>,
  location: RouteComponentProps['location'],
  dispatch: Dispatch<HistoryButtonsAction>
) {
  React.useEffect(
    function onLocationChange() {
      if (!location) {
        return
      }
      dispatch(pushLocation(match, location.search))
    },
    [dispatch, match, location]
  )
}

type HistorySyncComponentProps = {
  match: match<ShowRoutesParams>
  location: RouteComponentProps['location']
  dispatch: Dispatch<HistoryButtonsAction>
}

function HistorySyncComponent({
  match,
  location,
  dispatch,
}: HistorySyncComponentProps) {
  useSetHistory(match, location, dispatch)
  return null
}

type HistoryClearComponentProps = {
  dispatch: Dispatch<HistoryButtonsAction>
}

function HistoryClearComponent({ dispatch }: HistoryClearComponentProps) {
  React.useEffect(
    () => {
      dispatch(clearHistory())
    },
    [dispatch]
  )
  return null
}

// We only catch certain paths associated to notes show.
// It's the user meaningful paths: notes show principal routes.
// This way we ignore settings, comments routes etc..
// For channel home, we also include the channels show path
const HISTORY_ROUTES = [
  // Notes Show
  '/app/channels/:channelId/notes/:noteId/:options?',
  '/app/filters/:filterId/notes/:noteId/:options?',
  '/app/templates/:templateId',
]

const HISTORY_ROUTES_WITH_CHANNELS_SHOW = HISTORY_ROUTES.concat([
  // Channels Show
  '/app/channels/:channelId',
])

export type HistorySyncProps = {
  dispatch: Dispatch<HistoryButtonsAction>
}

export default function HistorySync({ dispatch }: HistorySyncProps) {
  return (
    <Switch>
      <Route
        exact
        path={HISTORY_ROUTES_WITH_CHANNELS_SHOW}
        render={({ match, location }) => (
          <HistorySyncComponent
            dispatch={dispatch}
            match={match}
            location={location}
          />
        )}
      />
      <Route
        path="/auth"
        render={() => {
          return <HistoryClearComponent dispatch={dispatch} />
        }}
      />
    </Switch>
  )
}
